import React, { useEffect, useMemo, useRef, useState } from "react";
import { trackFunnel, identifyFunnelUser } from "../../../services/funnelTracker";
import {
  IonButton,
  IonContent,
  IonFooter,
  useIonLoading,
  IonPage,
  IonIcon,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonLabel,
  IonActionSheet,
  IonImg,
} from "@ionic/react";
import PhoneInput from "../../../components/PhoneInput";
import { setAdoc_t } from "../../../redux/reducer/userSlice";
import "react-phone-number-input/style.css";
import { IonCheckbox } from "@ionic/react";

import { getUserInfo } from "../../../redux/actions/userActions";
import {
  getMinimumLegalAgeDate,
  isValidNickname,
  resolveAvatarImage,
  resolveUserAvatarSrc,
} from "../../../services/functions";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useHistory } from "react-router";
import { formatDDMMYY } from "../../../services/onboardingProfile";

import "../InitialConfiguration.min.css";
import "./PublicProfileStep.css";
import bgImage from "../../../assets/images/logo sfondo.png";
import { useIonRouter } from "@ionic/react";

import avatarDefault from "../../../assets/avatars/avatarDefault.png";
import avatars from "../../../assets/avatars";

import { cameraOutline, closeCircle } from "ionicons/icons";
import axios from "axios";

import { uploadAvatarAndSave } from "../../../redux/actions";
import { updateUserProperty } from "../../../redux/reducer/userSlice";
import {
  setInitialConfigExtraProperty,
  setInitialConfigProperty,
} from "../../../redux/reducer/initialConfigSlice";
import { updateMasterClubSubscriber } from "../../../redux/actions/initialConfigActions";
import { baseUrl, headersDefault } from "../../../redux/actions";
import { getAuthToken, writeAuth } from "../../../services/authStorage";
// ---------- helpers ----------
// ---------- helpers ----------
const trim = (v) => String(v ?? "").trim();

const countryFlagEmoji = (countryText = "") => {
  const t = String(countryText).toLowerCase().trim();
  if (t.includes("italia") || t.includes("italy")) return "🇮🇹";
  if (t.includes("francia") || t.includes("france")) return "🇫🇷";
  if (t.includes("germania") || t.includes("germany")) return "🇩🇪";
  if (t.includes("spagna") || t.includes("spain")) return "🇪🇸";
  if (t.includes("portogallo") || t.includes("portugal")) return "🇵🇹";
  if (
    t.includes("regno unito") ||
    t.includes("uk") ||
    t.includes("inghilterra") ||
    t.includes("united kingdom")
  )
    return "🇬🇧";
  return "🌍";
};

// ---------- SearchSelect (same structure as ProfileSettings) ----------
function SearchSelect({
  label,
  optional = false,
  placeholder = "Cerca…",
  valueText = "",
  term,
  setTerm,
  open,
  setOpen,
  leftPrefix,
  hint,
  results = [],
  loading,
  onPick,
  renderItem,
  disabled,
  maxItems = 8000,
  keepOpenOnPick = false,
  noSearch = false,
}) {
  const rootRef = React.useRef(null);
  const inputRef = React.useRef(null);

  const closeNow = React.useCallback(() => {
    setOpen(false);
    setTerm("");
  }, [setOpen, setTerm]);

  const openNow = React.useCallback(() => {
    if (disabled) return;
    setOpen(true);
    if (!noSearch) {
      setTimeout(() => inputRef.current?.setFocus?.(), 0);
    }
  }, [disabled, setOpen, noSearch]);

  const toggleOpen = React.useCallback(
    (e) => {
      e?.stopPropagation?.();
      if (disabled) return;
      if (open) closeNow();
      else openNow();
    },
    [disabled, open, closeNow, openNow],
  );

  React.useEffect(() => {
    if (!open) return;

    const onPointerDown = (e) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) {
        closeNow();
      }
    };

    document.addEventListener("pointerdown", onPointerDown, { passive: true });
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, [open, closeNow]);

  const shown = open ? term : valueText;
  const sliced = (results || []).slice(0, maxItems);

  return (
    <div
      ref={rootRef}
      className={`ps-field ps-field--select ${
        disabled ? "ps-field--disabled" : ""
      }`}
      style={{ position: "relative" }}
    >
      <div className="ps-label">
        {label}
        {optional ? <span className="ps-optional">facoltativo</span> : null}
      </div>

      <div
        className={[
          "ps-selectControl",
          leftPrefix ? "has-prefix" : "",
          disabled ? "is-disabled" : "",
        ].join(" ")}
        role="button"
        tabIndex={0}
        onClick={openNow}
        onKeyDown={(e) =>
          e.key === "Enter" || e.key === " " ? openNow() : null
        }
      >
        {leftPrefix ? (
          <span className="ps-selectPrefix" aria-hidden="true">
            {leftPrefix}
          </span>
        ) : null}

        <IonInput
          ref={inputRef}
          className="ps-input ps-input--select"
          value={shown}
          placeholder={placeholder}
          readonly={!open || noSearch}
          disabled={disabled}
          onIonFocus={noSearch ? undefined : openNow}
          onIonInput={(e) => { if (!noSearch) setTerm(e.detail?.value ?? ""); }}
          style={noSearch ? { pointerEvents: "none" } : undefined}
        />

        <span className="ps-selectChevron" aria-hidden="true" />

        <button
          type="button"
          className="ps-selectChevronBtn"
          aria-label={open ? "Chiudi elenco" : "Apri elenco"}
          onClick={toggleOpen}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") toggleOpen(e);
          }}
          tabIndex={disabled ? -1 : 0}
        />
      </div>

      {hint && open ? <div className="ps-hint">{hint}</div> : null}

      {open ? (
        <div className="ps-dropdown">
          <div className="ps-dropdownInner">
            {loading ? (
              <button type="button" className="ps-dropdownBtn">
                Caricamento…
              </button>
            ) : sliced.length ? (
              sliced.map((r, idx) => (
                <button
                  key={r?.id ?? r?.key ?? `${idx}`}
                  type="button"
                  className="ps-dropdownBtn"
                  onClick={() => {
                    onPick?.(r);
                    if (keepOpenOnPick) {
                      setTerm("");
                      return;
                    }
                    closeNow();
                  }}
                >
                  {renderItem ? renderItem(r) : r?.name ?? r?.text ?? ""}
                </button>
              ))
            ) : (
              <button type="button" className="ps-dropdownBtn">
                Nessun risultato
              </button>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
}

const isItalyLabel = (label) => /italia/i.test(String(label ?? ""));

const PublicProfileStep = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const history = useHistory();

  const {
    name,
    surname,
    nickname,
    country_id,
    extras,
    country_text,
    height,
    initial_weight,
    current_weight,
    birth_date,
    email,
    telephone,
    sex,
    province_id,
    province_text,
  } = useSelector((s) => s.initialConfig);

  // Lock Nome/Cognome when the name was provided by Apple at sign-in: Apple's
  // "Sign in with Apple" rules forbid re-asking for a name Apple already gives.
  // Prefilled + read-only here; users can still change it later in Profile
  // settings. Email/password sign-ups (no provider name) stay editable.
  const nameFromApple = (() => {
    try {
      return localStorage.getItem("onboarding_name_from_apple") === "1";
    } catch {
      return false;
    }
  })();
  const lockNameFields = nameFromApple && !!trim(name) && !!trim(surname);

  // ---- pending avatar (local) ----
  const PENDING_AVATAR_KEY = "adoc_pending_avatar";

  const myUserId = useSelector((s) => s.user?.user?.id);

  const safeJson = (s, fallback = null) => {
    try {
      return JSON.parse(s ?? "") ?? fallback;
    } catch {
      return fallback;
    }
  };

  const fileToDataUrl = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error("Impossibile leggere il file."));
      reader.onload = () => resolve(String(reader.result || ""));
      reader.readAsDataURL(file);
    });

  const dataUrlToFile = (dataUrl, fileName = "avatar.jpg") => {
    const [meta, b64] = String(dataUrl || "").split(",");
    const mime = (meta.match(/data:(.*?);base64/) || [])[1] || "image/jpeg";
    const binStr = atob(b64 || "");
    const len = binStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binStr.charCodeAt(i);
    return new File([bytes], fileName, { type: mime });
  };

  const findDefaultAvatarSrcByName = (avatarsObj, gender, name) => {
    const list = avatarsObj?.[gender] || [];
    const hit = list.find((x) => String(x?.name) === String(name));
    return hit?.image || "";
  };

  const capFirst = (v) => {
    const s = String(v ?? "");
    if (!s) return "";
    const first = s.charAt(0);
    return first === first.toUpperCase() ? s : first.toUpperCase() + s.slice(1);
  };

  // Interests (store in extras.hobbies)
  const hobbies = extras?.hobbies ?? [];

  const hobbiesRaw = Array.isArray(extras?.hobbies) ? extras.hobbies : [];
  const profileHydrated = useSelector(
    (s) => s.initialConfig?.hydratedFromProfile,
  );

  const HOBBY_OPTIONS = useMemo(
    () => [
      { key: "cucina", label: "Cucina" },
      { key: "sport", label: "Sport" },
      { key: "lettura", label: "Lettura" },
      { key: "benessere", label: "Benessere" },
      { key: "viaggi", label: "Viaggi" },
      { key: "musica", label: "Musica" },
    ],
    [],
  );

  const num = (v) => {
    const n = Number(String(v ?? "").replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  };

  const normalizeBirthDate = (v) => {
    const s = String(v ?? "").trim();
    if (!s) return "";
    const m = s.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return s; // fallback as-is if unknown format
    return `${m[1]}-${m[2]}-${m[3]}`; // ✅ keep only YYYY-MM-DD
  };

  const physicalPayload = useMemo(() => {
    const out = {};

    if (sex) out.sex = sex;

    const h = num(height);
    if (h > 0) out.height = h;

    const w = num(initial_weight);
    if (w > 0) out.initial_weight = w;

    // Peso attuale: a pending registration (older app builds) saves step 1 only
    // here, and it used to be left out. The server upserts today's diary row.
    const wc = num(current_weight);
    if (wc > 0) out.current_weight = wc;

    const bd = normalizeBirthDate(birth_date);
    if (bd) out.birth_date = bd;

    return out;
  }, [sex, height, initial_weight, current_weight, birth_date]);

  const hobbiesKeys = useMemo(() => {
    const mapByLabel = new Map(
      HOBBY_OPTIONS.map((o) => [o.label.toLowerCase(), o.key]),
    );
    const mapByKey = new Set(HOBBY_OPTIONS.map((o) => o.key));
    const out = [];
    for (const v of hobbiesRaw) {
      const s = String(v || "").trim();
      if (!s) continue;
      const low = s.toLowerCase();
      if (mapByKey.has(low)) out.push(low);
      else if (mapByLabel.has(low)) out.push(mapByLabel.get(low));
      else out.push(low);
    }
    return Array.from(new Set(out)).slice(0, 20);
  }, [hobbiesRaw, HOBBY_OPTIONS]);

  const toggleHobby = (key) => {
    const next = hobbiesKeys.includes(key)
      ? hobbiesKeys.filter((x) => x !== key)
      : [...hobbiesKeys, key];

    dispatch(setInitialConfigExtraProperty({ key: "hobbies", value: next }));
  };

  const [hobbyOpen, setHobbyOpen] = useState(false);
  const [hobbyTerm, setHobbyTerm] = useState("");

  const hobbyResults = useMemo(() => {
    const t = trim(hobbyTerm).toLowerCase();
    if (!hobbyOpen) return [];
    if (!t) return HOBBY_OPTIONS;
    return HOBBY_OPTIONS.filter((o) => o.label.toLowerCase().includes(t));
  }, [hobbyOpen, hobbyTerm, HOBBY_OPTIONS]);

  const selectedHobbyLabels = useMemo(() => {
    const map = new Map(HOBBY_OPTIONS.map((o) => [o.key, o.label]));
    return hobbiesKeys.map((k) => map.get(k) || k);
  }, [hobbiesKeys, HOBBY_OPTIONS]);

  // ---- Avatar state (match ProfileHeader behavior) ----
  const fileRef = useRef(null);
  const [avatarBusy, setAvatarBusy] = useState(false);
  const [showSourcePicker, setShowSourcePicker] = useState(false);
  const [showDefaultModal, setShowDefaultModal] = useState(false);
  const [selectedDefault, setSelectedDefault] = useState(null);

  const meAvatar = useSelector((s) => s.user?.user?.avatar);
  const meStoragePath = useSelector((s) => s.user?.user?.storage_path);

  const gender = sex === "female" ? "female" : "male";

  const avatarSrc = useMemo(() => {
    return (
      resolveUserAvatarSrc({ avatar: meAvatar, storage_path: meStoragePath }) ||
      avatarDefault
    );
  }, [meAvatar, meStoragePath]);

  const isDefaultAvatar = useMemo(() => {
    const raw = String(meAvatar ?? "").trim();
    if (!raw) return false;
    const resolved = resolveAvatarImage(raw);
    return !!resolved && resolved !== raw;
  }, [meAvatar]);

  const hasCustomAvatar =
    !!meAvatar &&
    !isDefaultAvatar &&
    !/^https?:\/\//i.test(String(meAvatar));

  // ---- Form state ----
  const isPendingRegistration =
    !!localStorage.getItem("adoc_rt") && !getAuthToken();
  const registrationToken = localStorage.getItem("adoc_rt");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [submitAttempted, setSubmitAttempted] = useState(false);

  const [presentSaving, dismissSaving] = useIonLoading();
  const savingCountRef = useRef(0);

  const showSavingOverlay = async (message = "Attendere prego...") => {
    savingCountRef.current += 1;
    if (savingCountRef.current === 1) {
      await presentSaving({ message });
    }
  };

  const hideSavingOverlay = async () => {
    savingCountRef.current = Math.max(0, savingCountRef.current - 1);
    if (savingCountRef.current === 0) {
      try {
        await dismissSaving();
      } catch {}
    }
  };

  // safety: ensure overlay is not left open on unmount
  useEffect(() => {
    return () => {
      savingCountRef.current = 0;
      try {
        dismissSaving();
      } catch {}
    };
  }, [dismissSaving]);

  const runWithSavingOverlay = async (fn) => {
    setSaving(true);
    await showSavingOverlay("Attendere prego...");
    try {
      return await fn();
    } finally {
      setSaving(false);
      await hideSavingOverlay();
    }
  };

  const setField = (key, value) => {
    setError("");
    dispatch(setInitialConfigProperty({ key, value }));
  };

  // Only name and surname are required (client, 14/09/2026); the CRM can still
  // make these mandatory. Optional until its answer arrives, so a slow response
  // never blocks SUCCESSIVO.
  const [mandatoryFields, setMandatoryFields] = useState({
    telephone: false,
    province: false,
    country_id: false,
  });
  const [mandatoryFieldsReady, setMandatoryFieldsReady] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const res = await fetch(
          `${baseUrl}/api/app/onboarding/mandatory-fields`,
          { headers: headersDefault() },
        );
        const data = await res.json().catch(() => ({}));
        if (!alive) return;
        setMandatoryFields({
          telephone: data?.telephone === true,
          province: data?.province === true,
          // The backend names it `country`.
          country_id: data?.country === true || data?.country_id === true,
        });
      } catch {
        if (!alive) return;
        setMandatoryFields({ telephone: false, province: false, country_id: false });
      } finally {
        if (alive) setMandatoryFieldsReady(true);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  // keep default country if empty — only when country is mandatory
  useEffect(() => {
    if (!mandatoryFieldsReady || !mandatoryFields.country_id) return;

    if (!country_id) {
      setField("country_id", 1);
      setField("country_text", "Italia");
      return;
    }

    if (country_id === 1 && (!country_text || !country_text.trim())) {
      setField("country_text", "Italia");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileHydrated, country_id, mandatoryFieldsReady, mandatoryFields.country_id]);

  useEffect(() => {
    let alive = true;
    if (!profileHydrated) return;

    // if ID exists but label missing, fetch default list once and resolve
    if (!country_id || (country_text && country_text.trim())) return;

    (async () => {
      try {
        const res = await fetch(
          `${baseUrl}/api/v1/user/registration/countries/search`,
          {
            headers: headersDefault(),
          },
        );
        const data = await res.json().catch(() => null);
        if (!alive) return;

        const list = Array.isArray(data) ? data : data?.data ?? [];
        const item = list.find((x) => String(x?.id) === String(country_id));
        const label = item?.text || item?.name || "";
        if (label) setField("country_text", label);
      } catch {}
    })();

    return () => {
      alive = false;
    };
  }, [profileHydrated, country_id, country_text]);

  const [phoneCountry, setPhoneCountry] = useState("IT");

  const isItaly = useMemo(() => {
    if (country_id === 1) return true;
    return String(country_text || "")
      .toLowerCase()
      .includes("italia");
  }, [country_id, country_text]);

  // ---------- Province search (Italia only) ----------
  const [provinceDidLoad, setProvinceDidLoad] = useState(false);
  const [provinceLoading, setProvinceLoading] = useState(false);
  const [provinces, setProvinces] = useState([]);

  const [provinceTerm, setProvinceTerm] = useState("");
  const [provinceResults, setProvinceResults] = useState([]);
  const [provinceOpen, setProvinceOpen] = useState(false);
  const provinceFiltered = useMemo(() => {
    if (!provinceOpen) return [];
    const t = trim(provinceTerm).toLowerCase();
    const base = provinces || [];

    if (!t) return base; // SearchSelect will slice via maxItems
    return base.filter((p) =>
      String(p?.name ?? p?.text ?? "")
        .toLowerCase()
        .includes(t),
    );
  }, [provinceOpen, provinceTerm, provinces]);

  useEffect(() => {
    let alive = true;
    if (!provinceOpen || !isItaly) return;

    if (provinces.length) {
      setProvinceDidLoad(true);
      return;
    }

    setProvinceLoading(true);

    (async () => {
      try {
        const res = await fetch(
          `${baseUrl}/api/v1/user/registration/provinces/search`,
          { headers: headersDefault() },
        );
        const data = await res.json().catch(() => null);
        if (!alive) return;

        const list = Array.isArray(data) ? data : data?.data ?? [];
        setProvinces(list);
      } catch {
        if (!alive) return;
        setProvinces([]);
      } finally {
        if (!alive) return;
        setProvinceLoading(false);
        setProvinceDidLoad(true);
      }
    })();

    return () => {
      alive = false;
    };
  }, [provinceOpen, isItaly, provinces.length]);

const initialNicknameRef = useRef("");
const nicknameTouchedRef = useRef(false);

  useEffect(() => {
    // baseline follows backend/programmatic updates until user types
    if (!nicknameTouchedRef.current) {
      initialNicknameRef.current = String(nickname ?? "").trim();
      setNicknameCheck({ checking: false, error: "" });
    }
  }, [nickname]);

  const [nicknameCheck, setNicknameCheck] = useState({
    checking: false,
    error: "",
  });

  const nicknameValue = String(nickname ?? "").trim();

  const isNicknameBlocking =
    nicknameCheck.checking || (!!nicknameValue && !!nicknameCheck.error);

  useEffect(() => {
    let alive = true;

    if (!nicknameTouchedRef.current) {
      setNicknameCheck({ checking: false, error: "" });
      return;
    }

    const current = String(nicknameValue ?? "").trim();
    const initial = String(initialNicknameRef.current ?? "").trim();

    if (current === initial) {
      setNicknameCheck({ checking: false, error: "" });
      return;
    }

    if (!current) {
      setNicknameCheck({ checking: false, error: "" });
      return;
    }

    // if (!isValidNickname(current)) {
    //   setNicknameCheck({
    //     checking: false,
    //     error:
    //       "Il nickname non è valido, deve avere da 4 a 30 caratteri e può contenere lettere, numeri, underscore, trattino e punto.",
    //   });
    //   return;
    // }

    setNicknameCheck((s) => ({ ...s, checking: true, error: "" }));

    const t = setTimeout(async () => {
      try {
        const res = await fetch(
          `${baseUrl}/api/v1/user/registration/check-nickname/${encodeURIComponent(
            current,
          )}`,
          { headers: headersDefault() },
        );

        const data = await res.json().catch(() => null);
        if (!alive) return;

        const ok = res.ok && data?.message === "Nickname disponibile";
        setNicknameCheck({
          checking: false,
          error: ok ? "" : "Il nickname non è disponibile",
        });
      } catch {
        if (!alive) return;
        setNicknameCheck({
          checking: false,
          error: "Si è verificato un problema, riprova più tardi.",
        });
      }
    }, 450);

    return () => {
      alive = false;
      clearTimeout(t);
    };
  }, [nicknameValue]);

  const selectedProvinceLabel = useMemo(() => {
    if (province_text && province_text.trim()) return province_text;
    if (!province_id) return "Seleziona";
    const item = provinces.find((p) => String(p.id) === String(province_id));
    return item?.name || item?.text || "Seleziona";
  }, [province_text, province_id, provinces]);

  useEffect(() => {
    let alive = true;

    const shouldLoad =
      isItaly &&
      (provinceOpen ||
        (!!province_id && (!province_text || !province_text.trim()))) &&
      !provinces.length;

    if (!shouldLoad) return;

    setProvinceLoading(true);

    (async () => {
      try {
        const res = await fetch(
          `${baseUrl}/api/v1/user/registration/provinces/search`,
          { headers: headersDefault() },
        );
        const data = await res.json().catch(() => null);
        if (!alive) return;

        const list = Array.isArray(data) ? data : data?.data ?? [];
        setProvinces(list);
      } catch {
        if (alive) setProvinces([]);
      } finally {
        if (alive) {
          setProvinceLoading(false);
          setProvinceDidLoad(true);
        }
      }
    })();

    return () => {
      alive = false;
    };
  }, [isItaly, provinceOpen, province_id, province_text, provinces.length]);

  // ---------- Country search ----------
  const [countryLoading, setCountryLoading] = useState(false);
  const [countryDidLoad, setCountryDidLoad] = useState(false);

  const [countryTerm, setCountryTerm] = useState("");
  const [countryResults, setCountryResults] = useState([]);
  const [countryOpen, setCountryOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!countryOpen) return;

    const t = trim(countryTerm);
    const isSearch = t.length >= 2;

    const url = isSearch
      ? `${baseUrl}/api/v1/user/registration/countries/search?term=${encodeURIComponent(
          t,
        )}`
      : `${baseUrl}/api/v1/user/registration/countries/search`; // ✅ no term -> default list

    setCountryLoading(true);

    const timer = setTimeout(
      async () => {
        try {
          const res = await fetch(url, { headers: headersDefault() });

          // optional fallback if backend requires term param:
          // if (!res.ok && !isSearch) res = await fetch(`${baseUrl}/api/nazioni/list?term=`, { headers: headersDefault() });

          const data = await res.json().catch(() => null);
          if (!alive) return;

          const list = Array.isArray(data) ? data : data?.data ?? [];
          setCountryResults(list);
        } catch {
          if (!alive) return;
          setCountryResults([]);
        } finally {
          if (!alive) return;
          setCountryLoading(false);
          setCountryDidLoad(true);
        }
      },
      isSearch ? 250 : 0,
    ); // ✅ instant load when empty

    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [countryOpen, countryTerm]);

  const selectedCountryLabel = useMemo(() => {
    if (country_text) return country_text;
    return "Italia";
  }, [country_text]);

  // ---------- Interests (keep IonSelect but style like ProfileSettings) ----------

  // ---------- Validation (same rules + same placement) ----------
  const fieldErrors = useMemo(() => {
    const e = {};
    if (!trim(name)) e.name = "Nome obbligatorio";
    if (!trim(surname)) e.surname = "Cognome obbligatorio";
    if (mandatoryFields.country_id && !country_id)
      e.country = "Nazione obbligatoria";
    if (mandatoryFields.telephone && !trim(telephone))
      e.telephone = "Cellulare obbligatorio";

    if (mandatoryFields.province && isItaly && !province_id)
      e.province = "Provincia obbligatoria";

    return e;
  }, [name, surname, country_id, telephone, isItaly, province_id, mandatoryFields]);

  const isFormValid = useMemo(
    () => Object.keys(fieldErrors).length === 0,
    [fieldErrors],
  );

  // ---------- Avatar actions (same UX as ProfileHeader) ----------
  const openSourcePicker = () => {
    setSelectedDefault(null);
    setShowSourcePicker(true);
  };

  const [pendingAvatar, setPendingAvatar] = useState(null);
  const savePendingAvatar = React.useCallback(
    (payload) => {
      localStorage.setItem(PENDING_AVATAR_KEY, JSON.stringify(payload));
      setPendingAvatar(payload);
    },
    [PENDING_AVATAR_KEY],
  );

  // shape:
  // { type: "default", name: "avatarX" }
  // { type: "file", dataUrl: "data:image/..", fileName: "x.jpg" }

  const clearPendingAvatar = React.useCallback(() => {
    localStorage.removeItem(PENDING_AVATAR_KEY);
    setPendingAvatar(null);
    setSelectedDefault(null);
  }, []);

  useEffect(() => {
    const stored = safeJson(localStorage.getItem(PENDING_AVATAR_KEY), null);
    if (stored?.type) setPendingAvatar(stored);
  }, []);

  const pendingAvatarSrc = useMemo(() => {
    if (!pendingAvatar) return "";
    if (pendingAvatar.type === "file" && pendingAvatar.dataUrl)
      return pendingAvatar.dataUrl;
    if (pendingAvatar.type === "default" && pendingAvatar.name) {
      return (
        findDefaultAvatarSrcByName(avatars, gender, pendingAvatar.name) ||
        avatarDefault
      );
    }
    return "";
  }, [pendingAvatar, gender]);

  const effectiveAvatarSrc = pendingAvatarSrc || avatarSrc;
  const hasRemovableAvatar = !!pendingAvatar || hasCustomAvatar;

  const openDefaultPicker = () => {
    // Pre-highlight the avatar the user currently has (a pending pick this
    // session, otherwise their saved default avatar).
    const current =
      pendingAvatar?.type === "default" ? pendingAvatar.name : meAvatar;
    setSelectedDefault(current || null);
    setShowDefaultModal(true);
  };

  const commitPendingRegistration = async () => {
    const bodyUpdate = {
      name: trim(name),
      surname: trim(surname),
      extra_data: [],
    };

    // No phone here: the registration update wants a verification time with it,
    // and upsertProfiloUtenti saves the number, unverified, right after.

    const resUpdate = await fetch(
      `${baseUrl}/api/v1/user/registration/${encodeURIComponent(
        registrationToken,
      )}/update`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyUpdate),
      },
    );

    if (!resUpdate.ok) {
      const msg =
        (await resUpdate.json().catch(() => null))?.message ??
        "Errore aggiornamento registrazione.";
      throw new Error(msg);
    }

    const resCommit = await fetch(
      `${baseUrl}/api/v1/user/registration/${encodeURIComponent(
        registrationToken,
      )}/commit`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      },
    );

    const dataCommit = await resCommit.json().catch(() => null);
    if (!resCommit.ok || !dataCommit?.token) {
      throw new Error(dataCommit?.message ?? "Errore commit registrazione.");
    }

    const bearer = dataCommit.token;

    // Write bearer to localStorage so headersDefault() picks it up for
    // the user-info request, but DON'T flip Redux's token yet — that's
    // what triggers RouteAuth to re-evaluate auth state. If we flipped
    // it now, RouteAuth would see hasBearer=true while user/subscriber
    // are still null, render <LoadingPage />, unmount this component,
    // dismiss the "Attendere prego…" overlay, then re-mount us fresh
    // with SUCCESSIVO re-enabled — the brief flash users reported.
    writeAuth("adoc_t", bearer);

    // Pull the profile. The fulfilled reducer writes Redux user +
    // master_club_subscriber AND localStorage adoc_p, so by the time
    // we flip the token below, RouteAuth has everything it needs.
    await dispatch(getUserInfo()).unwrap();

    // Now safe to drop the pending-registration marker and flip Redux.
    // Profile data is in place — RouteAuth's bootstrapMissingProfile
    // check returns false on this re-render, no LoadingPage interrupt.
    localStorage.removeItem("adoc_rt");
    dispatch(setAdoc_t(bearer));

    // The account exists from this moment — the commit call above is what
    // writes the `users` row. Until now the registration lived only in Redis,
    // which is why the earlier funnel steps can only be attributed to the
    // device id. Identify immediately so those anonymous events are claimed.
    trackFunnel("registration_completed");
    identifyFunnelUser();

    return bearer;
  };

  const onFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setAvatarBusy(true);
    setError("");

    try {
      // ✅ Always keep local pending only (preview uses pendingAvatarSrc)
      const dataUrl = await fileToDataUrl(file);

      savePendingAvatar({
        type: "file",
        dataUrl,
        fileName: file.name || "avatar.jpg",
      });
    } catch (err) {
      setError(err?.message || "Errore durante la selezione immagine.");
    } finally {
      setAvatarBusy(false);
      if (e?.target) e.target.value = "";
    }
  };

  const confirmDefaultAvatar = async () => {
    if (!selectedDefault) return;

    setAvatarBusy(true);
    setError("");

    try {
      // ✅ Always keep local pending only
      savePendingAvatar({ type: "default", name: selectedDefault });
      setShowDefaultModal(false);
    } catch (err) {
      setError(err?.message || "Errore durante la selezione avatar.");
    } finally {
      setAvatarBusy(false);
    }
  };

  const onDeleteAvatar = async () => {
    // ✅ if it's only local pending avatar, just clear it
    if (pendingAvatar) {
      clearPendingAvatar();
      return;
    }

    setAvatarBusy(true);
    setError("");

    try {
      await axios.post(
        `${baseUrl}/api/profilo-utenti`,
        JSON.stringify({ avatar: null }),
        { headers: headersDefault() },
      );

      dispatch(
        updateUserProperty({
          stateKey: "user",
          key: "avatar",
          value: null,
        }),
      );
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Errore durante la rimozione immagine.",
      );
    } finally {
      setAvatarBusy(false);
    }
  };

  const uploadPendingAvatarIfAny = async () => {
    const stored =
      pendingAvatar ?? safeJson(localStorage.getItem(PENDING_AVATAR_KEY), null);

    if (!stored) return;

    // ✅ must have bearer by now (commitPendingRegistration runs before this in persistAll)
    const hasBearer = !!getAuthToken();
    if (!hasBearer) return;

    try {
      // If your thunk requires userId, include it.
      // If it doesn't, it will simply ignore it.
      const baseArgs = myUserId ? { userId: myUserId } : {};

      if (stored.type === "default" && stored.name) {
        await dispatch(
          uploadAvatarAndSave({
            ...baseArgs,
            avatarNameFromPicker: stored.name,
          }),
        ).unwrap();
      } else if (stored.type === "file" && stored.dataUrl) {
        const file = dataUrlToFile(
          stored.dataUrl,
          stored.fileName || "avatar.jpg",
        );

        await dispatch(
          uploadAvatarAndSave({
            ...baseArgs,
            file,
          }),
        ).unwrap();
      }

      // ✅ refresh so the committed user sees the new avatar immediately
      try {
        await dispatch(getUserInfo()).unwrap();
      } catch {}

      clearPendingAvatar();
    } catch (e) {
      console.warn("Pending avatar upload failed:", e);
      // keep it pending so user can retry by pressing Next again
    }
  };

  // ---------- Save ----------
  const upsertProfiloUtenti = async ({ includeTelephone = true } = {}) => {
    const payload = {};

    if (String(name ?? "").trim()) payload.name = String(name).trim();
    if (String(surname ?? "").trim()) payload.surname = String(surname).trim();
    if (String(email ?? "").trim()) payload.email = String(email).trim();
	if (String(nickname ?? "").trim()) payload.nickname = String(nickname).trim();

    if (includeTelephone) {
      const tel = toE164ForIT(telephone);
      if (tel) payload.telephone = tel;
    }
    // ✅ IMPORTANT: preserve avatar (backend otherwise nulls it when omitted)
    const stateNow = store.getState();
    const currentAvatar = stateNow?.user?.user?.avatar;

    if (currentAvatar) {
      const raw = String(currentAvatar).trim();

      // prevent accidentally sending a bundled local asset path
      if (raw && !/avatardefault/i.test(raw)) {
        const looksBundled =
          /^\/(static\/media|assets\/)/i.test(raw) ||
          raw.includes("static/media/") ||
          raw.includes("assets/avatars/");

        if (!looksBundled) {
          // backend already accepts avatar in your upload flow
          payload.avatar = raw;

          // optional but matches what you described (avatar_url usage)
          const storagePath = String(stateNow?.user?.user?.storage_path ?? "").trim();
          const isUrl = /^https?:\/\//i.test(raw);
          const resolved = resolveAvatarImage(raw);
          const isDefaultAvatar = !!resolved && resolved !== raw;

          if (isUrl) payload.avatar_url = raw;
          else if (!isDefaultAvatar && storagePath) payload.avatar_url = `${storagePath}${raw}`;
        }
      }
    }

    if (Object.keys(payload).length === 0) return;

    await axios.post(`${baseUrl}/api/profilo-utenti`, payload, {
      headers: headersDefault(),
    });
  };

  const [telephoneServerError, setTelephoneServerError] = useState("");

  const toE164ForIT = (raw) => {
    const s = String(raw ?? "").trim();
    if (!s) return "";
    if (s.startsWith("+")) return s;

    const digits = s.replace(/\D/g, "");
    if (!digits) return "";

    if (digits.startsWith("00")) return `+${digits.slice(2)}`;
    if (digits.startsWith("39")) return `+${digits}`;
    return `+39${digits}`;
  };

  // The phone is saved as typed, unverified: onboarding no longer sends an SMS
  // (client, 14/09/2026). Free enrolment still asks for verification when the
  // CRM requires it.
  const phoneValue = useMemo(() => toE164ForIT(telephone), [telephone]);

  const handleBack = () => history.replace("/impostazioni-iniziali/1");

  const subscriberId = useSelector((s) => s.user?.master_club_subscriber?.id);

  const saveSubscriber = async () => {
    const payload = {
      // ✅ include step 1 values (only if present/valid)
      ...physicalPayload,

      // step 2 values
      nickname: String(nickname ?? "").trim(),
      name: String(name ?? "").trim(),
      surname: String(surname ?? "").trim(),
      country_id: mandatoryFields.country_id ? country_id || 1 : country_id ?? null,
      country_text: mandatoryFields.country_id
        ? String(country_text ?? "").trim() || selectedCountryLabel || "Italia"
        : String(country_text ?? "").trim() || selectedCountryLabel || "",
      province_id: isItaly ? province_id ?? null : null,
      province_text: isItaly
        ? String(province_text ?? "").trim() || selectedProvinceLabel || ""
        : "",
      extras: extras || {},
    };

    // ✅ DO NOT hardcode id: 1
    const id = subscriberId ?? 1;

    const resultAction = await dispatch(
      updateMasterClubSubscriber({ id, method: "PATCH", payload }),
    );

    if (updateMasterClubSubscriber.rejected.match(resultAction)) {
      throw new Error(resultAction.payload || "Errore salvataggio dati.");
    }
  };

  const persistAll = async ({ includeTelephone = true } = {}) => {
    if (isPendingRegistration) {
      await commitPendingRegistration();
    }

    await uploadPendingAvatarIfAny();
    await upsertProfiloUtenti({ includeTelephone });
    await saveSubscriber();
  };

  const handleNext = async () => {
    setSubmitAttempted(true);
    setError("");
    setTelephoneServerError("");

    if (!isFormValid) {
      const missing = Object.values(fieldErrors);
      setError(missing[0] || "Compila i campi obbligatori.");
      return;
    }

    setSaving(true);
    await showSavingOverlay("Attendere prego...");
    try {
      await persistAll({ includeTelephone: true });

      setField("telephone", toE164ForIT(telephone));

      initialNicknameRef.current = trim(nickname);
      nicknameTouchedRef.current = false;
      setNicknameCheck({ checking: false, error: "" });

      trackFunnel("onboarding_step_completed", { step: 2 });
      // Navigate while overlay is still visible — overlay will be cleaned up
      // by the useEffect unmount handler when this component unmounts
      history.replace("/impostazioni-iniziali/5");
    } catch (e) {
      setSaving(false);
      await hideSavingOverlay();
      const msg =
        e?.response?.data?.message || e?.message || "Ops! Errore. Riprova.";
      if (String(msg).toLowerCase().includes("telefono"))
        setTelephoneServerError(msg);
      else setError(msg);
    }
  };

  return (
    <IonPage className="ds-init ds-init--profile">
      <IonContent fullscreen className="ds-init__content">
        <div
          className="ds-init__bg"
          style={{ backgroundImage: `url('${bgImage}')` }}
          aria-hidden="true"
        />

        <div className="ds-init__wrap">
          <div className="ds-init__progress" aria-hidden="true">
            <span className="is-done" />
            <span className="is-active" />
            <span />
          </div>

          <div className="ds-init__title">
            Completa il tuo profilo per <br />
            farti riconoscere dalla nostra <br />
            Community.
          </div>

          {/* Photo / avatar */}
          <div className="ds-init__profileRow">
            <div className="ds-init__profileLeft">
              <div className="ds-init__rowLabel">
                FOTO PROFILO
                <span className="ps-optional">facoltativo</span>
              </div>

              <button
                type="button"
                className="ds-init__subhint"
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  textAlign: "left",
                }}
                onClick={openSourcePicker}
                disabled={avatarBusy}
              >
                o scegli il tuo avatar
              </button>
            </div>

            <button
              type="button"
              className="ds-init__avatarBtn"
              onClick={openSourcePicker}
              disabled={avatarBusy}
            >
              <div className="ds-init__avatarCircle" aria-hidden="true">
                <img
                  src={effectiveAvatarSrc}
                  alt="Avatar"
                  className="ds-init__avatarImg"
                />

                <span className="ds-init__avatarCam" aria-hidden="true">
                  <IonIcon icon={cameraOutline} />
                </span>

                {hasRemovableAvatar ? (
                  <span
                    className="ds-init__avatarDelete"
                    role="button"
                    tabIndex={0}
                    aria-label="Rimuovi foto profilo"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDeleteAvatar();
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        e.stopPropagation();
                        onDeleteAvatar();
                      }
                    }}
                  >
                    <IonIcon icon={closeCircle} />
                  </span>
                ) : null}
              </div>

              <input
                ref={fileRef}
                type="file"
                accept="image/*"
                onChange={onFileChange}
                style={{ display: "none" }}
              />
            </button>
          </div>

          <div className="ds-init__divider" style={{ marginTop: '8px', marginBottom: '8px' }} />

          {/* Fields (match ProfileSettings structure + styling) */}
          <div className="public-profile-step__form">
            {/* Nome */}
            <div className="ps-field">
              <IonLabel className="ps-label">Nome</IonLabel>
              <IonInput
                className="ps-input"
                value={name ?? ""}
                readonly={lockNameFields}
                onIonInput={(e) =>
                  setField("name", capFirst(e.detail.value ?? ""))
                }
              />
              {submitAttempted && fieldErrors.name ? (
                <div className="ps-error">{fieldErrors.name}</div>
              ) : null}
            </div>

            {/* Cognome */}
            <div className="ps-field">
              <IonLabel className="ps-label">Cognome</IonLabel>
              <IonInput
                className="ps-input"
                value={surname ?? ""}
                readonly={lockNameFields}
                onIonInput={(e) =>
                  setField("surname", capFirst(e.detail.value ?? ""))
                }
              />
              {submitAttempted && fieldErrors.surname ? (
                <div className="ps-error">{fieldErrors.surname}</div>
              ) : null}
            </div>

            {/* Nickname (optional) */}
            <div className="ps-field">
              <IonLabel className="ps-label">
                Nickname
                <span className="ps-optional">facoltativo</span>
              </IonLabel>
              <IonInput
                className="ps-input"
                value={nickname ?? ""}
                placeholder="Nome nella Community"
                onIonInput={(e) => {
                  nicknameTouchedRef.current = true; // ✅ enable checks only after manual edit
                  setField("nickname", e.detail.value ?? "");
                }}
              />
              {nicknameCheck.checking ? (
                <div className="ps-hint">Verifica disponibilità…</div>
              ) : null}

              {nicknameValue && nicknameCheck.error ? (
                <div className="ps-error">{nicknameCheck.error}</div>
              ) : null}
            </div>

            {/* Telefono */}
            <div className="ps-field ps-field--telefono">
              <div className="ps-labelRow">
                <div className="ps-label">
                  Telefono
                  {mandatoryFields.telephone ? null : (
                    <span className="ps-optional">facoltativo</span>
                  )}
                </div>
              </div>

              <div
                className={[
                  "ps-phoneWrap",
                  (submitAttempted && fieldErrors.telephone) ||
                  telephoneServerError
                    ? "is-invalid"
                    : "",
                ].join(" ")}
              >
                <PhoneInput
                  international={false}
                  defaultCountry="IT"
                  country={phoneCountry}
                  onCountryChange={(c) => c && setPhoneCountry(c)}
                  value={phoneValue}
                  onChange={(v) => {
                    setTelephoneServerError("");
                    setField("telephone", v ?? "");
                  }}
                />
              </div>
            </div>

            {submitAttempted && fieldErrors.telephone ? (
              <div className="ps-error">{fieldErrors.telephone}</div>
            ) : null}

            {!fieldErrors.telephone && telephoneServerError ? (
              <div className="ps-error">{telephoneServerError}</div>
            ) : null}

            {/* Nazione */}
            <SearchSelect
              label="Nazione"
              optional={!mandatoryFields.country_id}
              valueText={selectedCountryLabel}
              placeholder="Italia"
              leftPrefix={countryFlagEmoji(selectedCountryLabel)}
              open={countryOpen}
              setOpen={setCountryOpen}
              term={countryTerm}
              setTerm={setCountryTerm}
              results={countryResults}
              loading={countryOpen && (countryLoading || !countryDidLoad)}
              hint="Digita almeno 2 caratteri"
              onPick={(c) => {
                const id = c?.id;
                const label = c?.text || c?.name;
                if (!id || !label) return;

                setField("country_id", id);
                setField("country_text", label);
              }}
              renderItem={(c) => (
                <span>
                  <span className="ps-flagInList">
                    {countryFlagEmoji(c?.text || c?.name)}
                  </span>
                  {c?.text || c?.name}
                </span>
              )}
            />
            {submitAttempted && fieldErrors.country ? (
              <div className="ps-error">{fieldErrors.country}</div>
            ) : null}

            {isItaly ? (
              <>
                <SearchSelect
                  label="Provincia"
                  optional={!mandatoryFields.province}
                  valueText={selectedProvinceLabel}
                  placeholder="Seleziona"
                  open={provinceOpen}
                  setOpen={setProvinceOpen}
                  term={provinceTerm}
                  setTerm={setProvinceTerm}
                  results={provinceFiltered} // ✅ use filtered provinces
                  loading={
                    provinceOpen && (provinceLoading || !provinceDidLoad)
                  } // ✅
                  hint="Digita almeno 2 caratteri"
                  onPick={(p) => {
                    const id = p?.id;
                    const label = p?.text || p?.name;
                    if (!id || !label) return;

                    setField("province_id", id);
                    setField("province_text", label);
                  }}
                  renderItem={(p) => <span>{p?.text || p?.name}</span>}
                  // ✅ only once
                />

                {submitAttempted && fieldErrors.province ? (
                  <div className="ps-error">{fieldErrors.province}</div>
                ) : null}
              </>
            ) : null}

            {/* Interessi (keep IonSelect, but styled like ProfileSettings) */}
            <SearchSelect
              label="Hobby / Interessi"
              optional
              valueText={
                selectedHobbyLabels.length ? selectedHobbyLabels.join(", ") : ""
              }
              placeholder="Seleziona"
              open={hobbyOpen}
              setOpen={setHobbyOpen}
              term={hobbyTerm}
              setTerm={setHobbyTerm}
              results={hobbyResults.map((x) => ({ id: x.key, ...x }))}
              keepOpenOnPick
              noSearch
              onPick={(x) => {
                if (!x?.key) return;
                toggleHobby(x.key);
              }}
              renderItem={(x) => {
                const selected = hobbiesKeys.includes(x.key);
                return (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 12,
                    }}
                  >
                    <IonLabel>{x.label}</IonLabel>
                    <IonCheckbox
                      checked={selected}
                      style={{ pointerEvents: "none" }}
                    />
                  </div>
                );
              }}
            />

            {/* global error (same placement style) */}
            {error ? (
              <div className="public-profile-step__formError">{error}</div>
            ) : null}

            {submitAttempted && !isFormValid ? (
              <div className="public-profile-step__formError">
                Compila tutti i campi obbligatori.
              </div>
            ) : null}
          </div>

        </div>

        {/* Avatar source picker (exact behavior like ProfileHeader) */}
        <IonActionSheet
          isOpen={showSourcePicker}
          onDidDismiss={() => setShowSourcePicker(false)}
          header="Seleziona origine"
          buttons={[
            {
              text: "Immagini predefinite",
              handler: () => openDefaultPicker(),
            },
            {
              text: "Carica immagine",
              handler: () => fileRef.current?.click(),
            },
            { text: "Annulla", role: "cancel" },
          ]}
        />

        {/* Default avatars modal (same pattern as ProfileHeader) */}
        <IonModal
          isOpen={showDefaultModal}
          onDidDismiss={() => setShowDefaultModal(false)}
          className="modal-as-alert"
          keepContentsMounted={false}
        >
          <h3 className="ion-padding-horizontal">Scegli il tuo avatar</h3>

          <div className="public-profile-step__avatarGridWrap">
            <div className="public-profile-step__avatarGrid">
              {(avatars?.[gender] || []).map((a) => (
                <button
                  key={a.name}
                  type="button"
                  className={`public-profile-step__avatarPickBtn ${
                    selectedDefault === a.name ? "is-selected" : ""
                  }`}
                  onClick={() => setSelectedDefault(a.name)}
                >
                  <IonImg
                    src={a.image}
                    className="public-profile-step__avatarPickImg"
                  />
                </button>
              ))}
            </div>
          </div>

          <IonButton
            onClick={confirmDefaultAvatar}
            disabled={avatarBusy || !selectedDefault}
            color="primary"
            expand="block"
            fill="clear"
            strong
          >
            Confermare
          </IonButton>
        </IonModal>

      </IonContent>

      <IonFooter className="ds-init__footer--fixed">
        <div className="ds-init__footer ds-init__footer--two">
          <IonButton
            className="ds-init__back"
            fill="clear"
            color="medium"
            onClick={handleBack}
            disabled={saving}
          >
            INDIETRO
          </IonButton>

          <IonButton
            className="ds-init__next"
            color="primary"
            disabled={saving || isNicknameBlocking}
            onClick={handleNext}
          >
            SUCCESSIVO
          </IonButton>
        </div>
      </IonFooter>
    </IonPage>
  );
};

export default PublicProfileStep;
